import join from 'url-join'

import { createAction, asyncAction, http } from '../util/index.js'
import config from '../config.js'

export const clearUserCheck = createAction('CLEAR_USER_CHECK', { noPayload: true })
export const setUserCheckResults = createAction('SET_USER_CHECK_RESUTS')
export const clearAccessBotResults = createAction('CLEAR_ACCESS_BOT_RESULTS')
export const clearUserStatus = createAction('CLEAR_USER_STATUS')

const api = join.bind(null, config.apiUrl)

export const getUserAccessStatus = asyncAction({
    baseName: 'getUserAccessStatus',
    action: action => (username) => (dispatch) => {        
        dispatch(action.start())
        return http.get(api(`/ssp/access/status?user=${username}`))
        .then(appStatus => {
            dispatch(action.success(appStatus))                            
        }).catch(err => {
            console.error('error getting api response', err)
            dispatch(action.error(err))
        })
    }
  })
  
export const triggerAccessBot = asyncAction({
    baseName: 'triggerAccessBot',
    action: action => (username, app) => (dispatch) => {
        dispatch(action.start())
        return http.get(api(`/ssp/access/?user=${username}&app=${app}`))
        .then(botResults => {
            dispatch(action.success(botResults))
            dispatch(getUserAccessStatus(username))            
        }).catch(err => {
            console.error('error getting api response', err)
            dispatch(action.error(err))
        })
    }
  })

export const checkUserExists = asyncAction({
    baseName: 'checkUserExists',
    action: action => (user) => (dispatch) => {
        dispatch(action.start())
        return http.get(api(`/ssp/user/check?user=${user}`))
        .then(checkResults => {
            dispatch(action.success(checkResults))
        }).catch(err => {
            console.error('error getting api response', err)
            dispatch(action.error(err))
        })
    }
  })


// WEBPACK FOOTER //
// ./client/src/accessSelfService/actions.js